<template>
    <b-modal
      :title="`Manual - ${titleVideo}`"
      no-close-on-backdrop
      size="xl"
      ok-only
      centered
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
      :busy="loading"
      ok-title="Fechar"
      ok-variant="danger"
    >
      <b-col>
        <iframe
          width="100%"
          height="600px"
          :src="`https://www.youtube.com/embed/${getYoutubeVideoUri(url)}`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </b-col>
    </b-modal>
</template>
<script>

import { getYoutubeVideoUri } from 'Utils/index.js';

export default {
  name: 'VideoManual',
  
  data() {
    return {
      loading: false,
      open: false,
      url: '',
      titleVideo: '',
    };
  },

  methods: {
    getYoutubeVideoUri,
    toggleOpen({ url = '', title = '' }) {
      this.open = !this.open;
      this.url = url;
      this.titleVideo = title;
    },
  },
};
</script>
<style></style>
